/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_LiveInputs */

const cs_builder_sync_live = /** @type {(inputs: Builder_Sync_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Živě`)
};

const en_builder_sync_live = /** @type {(inputs: Builder_Sync_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Builder_Sync_LiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_live = /** @type {((inputs?: Builder_Sync_LiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_LiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_live(inputs)
	return cs_builder_sync_live(inputs)
});